import {http} from './config';
export default{
    listarUsuarios:()=>{
        return http.get('api/usuarios');
    },
    save:(usuario)=>{
        return http.post('api/register',usuario)
    },
    update:(usuario)=>{
        return http.put('api/usuario',usuario)
    },
    delete:(usuario)=>{
        return http.delete('api/usuario/'+usuario.id)
    },
    obtenerUsuarioPorIdentificador:(identificador)=>{
        return http.get('/api/user/busqueda_usuario_identificador/'+identificador);
    },
    edit_identificador:(usuario)=>{
        return http.post('api/edit_identificador/',usuario)
    },cambiarEstado:(usuario)=>{
        return http.post('api/user/cambiar_estado_principal',usuario)
    },solicitarPublicacion:(usuario)=>{
        return http.post('api/user/solicitar_publicacion',usuario)
    },
    getUsuarioParaVendedor:(identificador)=>{
        return http.get('/api/user/get_usuario_para_vendedor/'+identificador);
    },



    
}
